module.exports = __webpack_public_path__ + "img/producer-page.c059e1fc.png";